module.exports = __webpack_public_path__ + "static/media/LOGO SDI.c0d8229e.jpg";